import axios from 'axios';

const BASE_URL = localStorage.getItem("selected_server") || "https://api.turnaments.com";

const api = axios.create({
  baseURL: BASE_URL,
});

// Her istekten önce araya gir (Request Interceptor)
api.interceptors.request.use(
  (config) => {
    // LocalStorage'dan dili oku, yoksa varsayılan olarak 'tr' kullan
    const language = localStorage.getItem("app_lang") || "tr";
    
    // Backend'in beklediği header ismine göre ekle (Genelde Accept-Language kullanılır)
    config.headers['Accept-Language'] = language;
    
    // Eğer backend özel bir header bekliyorsa şu şekilde de yazabilirsin:
    // config.headers['x-language'] = language;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;